<template>
  <div id="loading-bg">
    <div class="loading-logo">
      <img src="@/assets/images/logo/logo.png" alt="Logo">
    </div>
    <div class="loading">
      <div class="effect-1 effects"></div>
      <div class="effect-2 effects"></div>
      <div class="effect-3 effects"></div>
    </div>
  </div>
</template>

<script>
export default {
  created () {
    this.$router.push(`/project/${localStorage.personal_project_guid}`)
  }
}

</script>

<style lang="scss">
@import "../../assets/css/loader.css";
</style>
